import React from 'react';
import { RotateCcwIcon, TimerIcon } from 'lucide-react';
type ProblemCardProps = {
  variant: 'blue' | 'gold' | 'navy';
  title: string;
  paragraphs: string[];
  highlight: string;
};
const styles = {
  blue: {
    card: 'border border-line border-l-[5px] border-l-brand bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-brand'
  },
  gold: {
    card: 'border border-line border-l-[5px] border-l-gold bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-goldDark'
  },
  navy: {
    card: 'bg-navy',
    title: 'text-white',
    body: 'text-onNavyMuted',
    hl: 'text-gold'
  }
};
export function ProblemCard({
  variant,
  title,
  paragraphs,
  highlight
}: ProblemCardProps) {
  const s = styles[variant];
  const Icon = variant === 'gold' ? RotateCcwIcon : variant === 'navy' ? TimerIcon : null;
  return <article className={`rounded-md px-4 py-3.5 md:px-4 md:py-4 ${s.card}`} data-id="element-147" data-mp="6tiir1nbde5s">
      <h2 className={`font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] md:text-[24px] ${s.title}`} data-id="element-148" data-mp="bs3nnedigm0k">
        {Icon && <Icon className="mr-2 inline h-5 w-5 -translate-y-0.5 text-gold md:h-6 md:w-6" strokeWidth={2.5} aria-hidden data-id="element-149" data-mp="1dvh1867q4t2q" />}
        {title}
      </h2>
      <div className={`mt-1.5 space-y-1.5 text-[14px] leading-[1.4] md:text-[15px] ${s.body}`} data-id="element-150" data-mp="191w2gbyb3v2h">
        {paragraphs.map(p => <p key={p} data-id="element-151" data-mp="103kdeed395c5">{p}</p>)}
      </div>
      <p className={`mt-1.5 font-heading text-[12px] font-extrabold uppercase leading-tight md:text-[14px] ${s.hl}`} data-id="element-152" data-mp="104vg0auss71o">
        {highlight}
      </p>
    </article>;
}